// extracted by mini-css-extract-plugin
export default {"loading":"styles-module--loading--bad67","pulse":"styles-module--pulse--08775"};